"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fraction = void 0;
var Fraction;
(function (Fraction) {
    Fraction["Half"] = "u-1/2";
    Fraction["HalfAtSmall"] = "u-1/2@s";
    Fraction["HalfAtMedium"] = "u-1/2@m";
    Fraction["HalfAtLarge"] = "u-1/2@l";
    Fraction["Third"] = "u-1/3";
    Fraction["ThirdAtSmall"] = "u-1/3@s";
    Fraction["ThirdAtMedium"] = "u-1/3@m";
    Fraction["ThirdAtLarge"] = "u-1/3@l";
    Fraction["TwoThirds"] = "u-2/3";
    Fraction["TwoThirdsAtSmall"] = "u-2/3@s";
    Fraction["TwoThirdsAtMedium"] = "u-2/3@m";
    Fraction["TwoThirdsAtLarge"] = "u-2/3@l";
    Fraction["Quarter"] = "u-1/4";
    Fraction["QuarterAtSmall"] = "u-1/4@s";
    Fraction["QuarterAtMedium"] = "u-1/4@m";
    Fraction["QuarterAtLarge"] = "u-1/4@l";
    Fraction["ThreeQuarters"] = "u-3/4";
    Fraction["ThreeQuartersAtSmall"] = "u-3/4@s";
    Fraction["ThreeQuartersAtMedium"] = "u-3/4@m";
    Fraction["ThreeQuartersAtLarge"] = "u-3/4@l";
})(Fraction = exports.Fraction || (exports.Fraction = {}));
//# sourceMappingURL=Fraction.js.map